import React, { useMemo } from "react";

import { HubHookFormSelect } from "../HubHookFormSelect";
import { useIndustryListWithCache } from "./useIndustryListWithCache";

export const IndustryHookFormSelect = ({
  name = "industry",
  label = "Industry",
  hideLabel = false,
  dispatch = () => {},
  required = true,
  disabled = false,
  ...rest
}) => {
  const { industries, isLoading } = useIndustryListWithCache();

  const options = useMemo(() => industries || [], [industries]);

  return (
    <HubHookFormSelect
      name={name}
      options={options}
      required={required}
      disabled={disabled || isLoading}
      {...(!hideLabel ? { label } : {})}
      {...rest}
    />
  );
};

export default IndustryHookFormSelect;